import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoginAsTenantParamsGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!!route.queryParams.token && !!route.queryParams.XTenantId) {
      return true;
    } else {
      return this.router.createUrlTree(['/']);
    }
  }
}
